export default __webpack_public_path__ + "static/webRotator/svg/f7d61742049c3ee60c797c81917c8f75.svg";